(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nadel-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nadel-footer')) {
    customElements.define('nadel-footer', class extends HTMLElement {
      connectedCallback() {
        this.media = window.matchMedia('(max-width: 749px)');
        this.update = () => this.querySelectorAll('details').forEach(detail => { detail.open = !this.media.matches; });
        this.preventDesktopToggle = event => {
          if (!this.media.matches && event.target.closest('summary')) event.preventDefault();
        };
        this.media.addEventListener('change', this.update);
        this.addEventListener('click', this.preventDesktopToggle);
        this.update();
      }
      disconnectedCallback() {
        this.media.removeEventListener('change', this.update);
        this.removeEventListener('click', this.preventDesktopToggle);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nadel-services"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nadel-service-strip')) {
    customElements.define('nadel-service-strip', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const list = this.querySelector('.nadel-services__list');
        const buttons = [...this.querySelectorAll('[data-service-index]')];
        const update = () => {
          const index = Math.round(list.scrollLeft / list.clientWidth);
          buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        };
        list.addEventListener('scroll', update, {passive: true, signal});
        buttons.forEach((button, index) => button.addEventListener('click', () => {
          list.scrollTo({left: index * list.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }, {signal}));
        update();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sofia-discount-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sofia-discount-bar')) {
    customElements.define('sofia-discount-bar', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.messages = Array.from(this.querySelectorAll('[data-promotion]'));
        if (this.messages.length < 2) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.current = 0;
        document.addEventListener('visibilitychange', () => this.start(), options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.messages.indexOf(event.target.closest('[data-promotion]'));
          if (index < 0) return;
          this.stop();
          this.show(index);
        }, options);
        this.start();
      }
      show(index) {
        this.current = index;
        this.messages.forEach((message, i) => { message.hidden = i !== index; });
      }
      start() {
        this.stop();
        if (document.hidden) return;
        this.timer = setInterval(() => this.show((this.current + 1) % this.messages.length), Number(this.dataset.interval) || 4000);
      }
      stop() { clearInterval(this.timer); }
      disconnectedCallback() {
        this.stop();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-testimonial-12"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lm-testimonial-carousel')) {
    customElements.define('lm-testimonial-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.cards = Array.from(this.querySelectorAll('[data-review]'));
        this.dots = Array.from(this.querySelectorAll('[data-review-dot]'));
        if (!this.cards.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.mobile = window.matchMedia('(max-width: 1023px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.current = Math.min(Number(this.dataset.initial) || 0, this.cards.length - 1);
        this.manualPause = false;
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index, true), options));
        this.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 : this.current + (event.key === 'ArrowRight' ? 1 : -1);
          this.go(index, true);
          this.dots[this.current]?.focus({ preventScroll: true });
        }, options);
        const stage = this.querySelector('.lm-testimonials__stage');
        stage.addEventListener('pointerdown', (event) => {
          if (event.button !== 0 || event.target.closest('a, button, input, video')) return;
          this.start = { x: event.clientX, y: event.clientY };
        }, options);
        stage.addEventListener('pointerup', (event) => {
          if (!this.start) return;
          const dx = event.clientX - this.start.x;
          const dy = event.clientY - this.start.y;
          this.start = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) this.go(this.current + (dx < 0 ? 1 : -1), true);
        }, options);
        stage.addEventListener('pointercancel', () => { this.start = null; }, options);
        this.addEventListener('mouseenter', () => this.stop(), options);
        this.addEventListener('mouseleave', () => this.play(), options);
        this.addEventListener('focusin', () => this.stop(), options);
        this.addEventListener('focusout', () => this.play(), options);
        this.mobile.addEventListener('change', () => this.render(), options);
        this.reduced.addEventListener('change', () => { this.stop(); this.play(); }, options);
        document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.play(), options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.cards.indexOf(event.target.closest('[data-review]'));
          if (index >= 0) this.go(index, true);
        }, options);
        this.render();
        this.play();
      }
      go(index, manual = false) {
        this.current = (index + this.cards.length) % this.cards.length;
        if (manual) { this.manualPause = true; this.stop(); }
        this.render();
      }
      render() {
        const total = this.cards.length;
        this.cards.forEach((card, index) => {
          const active = index === this.current;
          const previous = total > 1 && index === (this.current - 1 + total) % total;
          const next = total > 2 && index === (this.current + 1) % total;
          card.classList.toggle('is-active', active);
          card.classList.toggle('is-previous', previous);
          card.classList.toggle('is-next', next);
          const visible = active || (!this.mobile.matches && (previous || next));
          card.setAttribute('aria-hidden', String(!visible));
          card.inert = !visible;
          if (visible) {
            const image = card.querySelector('.lm-testimonial__avatar');
            if (image) image.loading = 'eager';
          }
        });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.current)));
      }
      play() {
        this.stop();
        if (this.dataset.autoplay !== 'true' || this.manualPause || this.reduced.matches || document.hidden || this.matches(':hover, :focus-within') || this.cards.length < 2) return;
        this.timer = setInterval(() => this.go(this.current + 1), Math.max(Number(this.dataset.delay) || 5000, 3000));
      }
      stop() { clearInterval(this.timer); }
      disconnectedCallback() { this.stop(); this.controller?.abort(); this.controller = null; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
